import Grouping from "./Grouping.js";

/**
 * @version 2022-05-22
 * @author Patrik Harag
 */
class MonthGrouping extends Grouping {
    _keyFunc(transaction) {
        return transaction.getDate().substr(0, 7);
    }

    _follows(key) {
        let year = Number.parseInt(key.substr(0, 4));
        let month = Number.parseInt(key.substr(5, 7));
        if (month === 12) {
            month = 1;
            year++;
        } else {
            month++;
        }
        return `${year}-${month < 10 ? '0' + month : month}`;
    }
}

/**
 * @version 2022-05-22
 * @author Patrik Harag
 */
class YearGrouping extends Grouping {
    _keyFunc(transaction) {
        return transaction.getDate().substr(0, 4);
    }

    _follows(key) {
        let year = Number.parseInt(key);
        year++;
        return '' + year;
    }
}

/**
 * @version 2022-05-22
 * @author Patrik Harag
 */
class SumGrouping extends Grouping {
    _keyFunc(transaction) {
        return 'Σ';
    }
}

/**
 * @version 2026-09-01
 * @author Patrik Harag
 */
export default class Groupings {
    static NO_GROUPING = null;
    static GROUP_BY_MONTH = new MonthGrouping();
    static GROUP_BY_YEAR = new YearGrouping();
    static GROUP_ALL = new SumGrouping();
}
